import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-surface">
      <div className="container-px mx-auto max-w-7xl py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 text-sm text-muted-foreground max-w-sm">
              Revisão jurídica de contratos por advogados qualificados, com pré-análise de IA. Tech-first, transparente, sem burocracia.
            </p>
          </div>
          <div>
            <h4 className="font-serif text-sm font-medium mb-3">Produto</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/como-funciona" className="hover:text-foreground">Como funciona</Link></li>
              <li><Link to="/advogados" className="hover:text-foreground">Advogados</Link></li>
              <li><Link to="/precos" className="hover:text-foreground">Preços</Link></li>
              <li><Link to="/cadastro/advogado" className="hover:text-foreground">Para advogados</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-sm font-medium mb-3">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#" className="hover:text-foreground">Termos de uso</a></li>
              <li><a href="#" className="hover:text-foreground">Privacidade</a></li>
              <li><a href="#" className="hover:text-foreground">LGPD</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-border/40 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Parecer.ai — Todos os direitos reservados.
          </p>
          <p className="text-xs text-muted-foreground">
            Plataforma intermediadora. Não prestamos serviços jurídicos diretamente.
          </p>
        </div>
      </div>
    </footer>
  );
}
